import type { SemanticStatus } from '@oneup/shared';

export type BadgeVariant =
  | 'default'
  | 'secondary'
  | 'outline'
  | 'success'
  | 'warning'
  | 'destructive'
  | 'info'
  | 'muted';

export function taskStatusVariant(status: SemanticStatus | undefined): BadgeVariant {
  if (status === 'done') return 'success';
  if (status === 'in_progress') return 'info';
  if (status === 'waiting_on_client' || status === 'review') return 'warning';
  if (status === 'open') return 'default';
  return 'muted';
}
